import { useState } from "react";
import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { printFile } from "@/lib/api/files";

/**
 * Bo'sh LP va tara yorliqlari (LBL-01/02).
 *
 * Nazoratchi tovarni TARAga yig'adi va tara yorlig'ini skanerlaydi —
 * tara tizimda oldindan bo'lishi shart. Yorliq chiqarish bo'sh LP
 * yaratadi (holat EMPTY, joysiz): qoldiq ham, harakat ham paydo
 * bo'lmaydi, kod esa qayta ishlatilmaydi.
 *
 * Yorliq to'g'ridan-to'g'ri printerga ketadi — fayl saqlanmaydi.
 */
export function LpLabels({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [count, setCount] = useState("8");
  const [type, setType] = useState("CONTAINER");
  const [state, setState] = useState<{ busy: boolean; error?: unknown }>({ busy: false });
  const amount = Number(count);
  const valid = Number.isInteger(amount) && amount >= 1 && amount <= 200;

  const close = () => {
    setState({ busy: false });
    onClose();
  };

  return (
    <ConfirmDialog
      open={open}
      title="Bo'sh LP va tara yorliqlari"
      description="Har LP — bitta A4 varaq: yirik kod, Code 128 shtrix-kod va chiqarilgan sana-vaqt. Chop etish dialogi ochiladi. Kodlar ketma-ketlikdan; tovar kirimi yaratilmaydi. Nazorat tarasi uchun — «Tara»."
      confirmLabel="Chop etish"
      busy={state.busy}
      error={state.error}
      confirmDisabled={!valid}
      extra={
        <div className="grid-2">
          <label className="field">
            <span className="field-label">Soni (1–200)</span>
            <input
              className="input mono"
              inputMode="numeric"
              value={count}
              onChange={(event) => setCount(event.target.value)}
            />
          </label>
          <label className="field">
            <span className="field-label">Turi</span>
            <select className="input" value={type} onChange={(event) => setType(event.target.value)}>
              <option value="CONTAINER">Tara</option>
              <option value="PALLET">Pallet</option>
              <option value="BOX">Korobka</option>
            </select>
          </label>
        </div>
      }
      onClose={close}
      onConfirm={() => {
        setState({ busy: true });
        printFile("inventory", "/api/v1/license-plates/labels", `lp-yorliqlar-${amount}.pdf`, {
          new_count: amount,
          lp_type: type,
          reason: "Bo'sh yorliqlar (admin)",
        })
          .then(close)
          .catch((cause: unknown) => setState({ busy: false, error: cause }));
      }}
    />
  );
}
